import { JURISDICTIONS } from '../constants/jurisdictions.ts';

const JURISDICTION_NAME_BY_ID = new Map(JURISDICTIONS.map((j) => [j.id, j.name]));

function normalizeZoneId(raw: string): string {
  let s = raw.trim().replace(/\uFF5C/g, '|');
  try {
    if (s.includes('%')) s = decodeURIComponent(s);
  } catch {
    /* ignore */
  }
  return s;
}

export function parseListedZoneJurisdictionId(zoneId: string): number | null {
  const s = normalizeZoneId(zoneId);
  if (!s) return null;
  const lo = s.toLowerCase();
  if (lo.startsWith('fb|')) {
    const parts = s.split('|');
    if (parts.length >= 3) {
      const n = Number(parts[1].trim());
      if (Number.isFinite(n) && JURISDICTION_NAME_BY_ID.has(n)) return n;
    }
  }
  const two = s.match(/^(\d{1,3})\|(.+)$/);
  if (two) {
    const n = Number(two[1]);
    if (Number.isFinite(n) && JURISDICTION_NAME_BY_ID.has(n)) return n;
  }
  const m = s.match(/\|(\d{1,3})\|/);
  if (m) {
    const n = Number(m[1]);
    if (Number.isFinite(n) && JURISDICTION_NAME_BY_ID.has(n)) return n;
  }
  return null;
}

export function listedZoneJurisdictionLabel(jurisdictionId: number): string {
  return JURISDICTION_NAME_BY_ID.get(jurisdictionId) ?? `Jurisdicción ${jurisdictionId}`;
}
